const SRC = {
  navyStripe: "/brand/lines/line-1.png",
  pinkStripe: "/brand/lines/line-2.png",
  navyFill: "/brand/lines/line-3.png",
};

// variant: navyStripe | pinkStripe | toNavy | fromNavy
export function BrandCurve({ variant, bg, to }) {
  const flip = variant === "fromNavy";
  const src = variant === "toNavy" || flip ? SRC.navyFill : SRC[variant];
  const h = variant.endsWith("Stripe") ? "h-auto -my-6 md:-my-16" : "h-16 md:h-32";
  return (
    <div className="w-full leading-[0] -my-px relative z-[1]" style={{ background: to ? `linear-gradient(180deg, ${bg} 0%, ${bg} 45%, ${to} 100%)` : bg }} data-testid={`brand-curve-${variant}`}>
      <img src={src} alt="" aria-hidden="true" className={`block w-full ${h} object-fill select-none pointer-events-none`} style={flip ? { transform: "scaleY(-1)" } : undefined} />
    </div>
  );
}

export function BrandGlow({ className = "" }) {
  return <img src="/brand/lines/line-4.png" alt="" aria-hidden="true" className={`absolute pointer-events-none select-none ${className}`} />;
}

export function BrandAccent({ className = "" }) {
  return <img src="/brand/lines/line-5.png" alt="" aria-hidden="true" data-testid="brand-accent" className={`block w-[220px] h-auto ${className}`} />;
}
